var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":"подтверждение email-a"}},[_c('b-alert',{attrs:{"variant":"danger","show":_vm.showError}},[_vm._v(" Что-то пошло не так, пожалуйста, свяжитесь с нами через форму обратной связи и мы постараемся помочь. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }